@if (record) {
  <div class="record-info">

    <!-- Schedule card -->
    <div class="card">
      <div class="card-header">
        <div class="card-title">Schedule</div>
      </div>
      <div class="card-body">
        <!-- Title -->
        <div class="row" [class.disabled]="disabled">
          <div class="label">Title</div>
          <input class="input" [(ngModel)]="record.title" (blur)="updateRecord()">
        </div>

        <!-- Date / Time / Timezone -->
        <div class="line" [class.disabled]="disabled">
          <div class="row">
            <div class="label">Start Date</div>
            <input class="input date-input" [matDatepicker]="picker" [min]="minDate" [value]="startTime" (dateChange)="updateDate($event)" (focus)="picker.open()" placeholder="Select...">
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="row">
            <div class="label">Time</div>
            <input class="input time-input" appTimeMask [(ngModel)]="startTime" (blur)="updateRecord()">
          </div>
          <div class="row">
            <div class="label">Time Zone</div>
            <app-select class="select" [options]="recordOptions.timezones" [selected]="timezone" (selectedChange)="updateTimezone($event)"></app-select>
          </div>
        </div>

        <!-- Duration -->
        @if (project?.startTrigger?.type === 'startTime') {
          <div class="line" [class.disabled]="disabled">
            <div class="row">
              <div class="label">Duration</div>
              <app-select class="select" [options]="recordOptions.duration" [selected]="record.durationType" (selectedChange)="updateDuration($event)"></app-select>
            </div>
            <div class="row">
              <div class="label">Value</div>
              @if (record.durationType === 'seconds') {
                <input class="input" type="number" min="0" [(ngModel)]="durationMinutes">
              } @else {
                <input class="input" [(ngModel)]="record.durationValue" (blur)="updateRecord()">
              }
            </div>
          </div>
        }
      </div>
    </div>

    <!-- Metadata (legacy rows) -->
    <div class="metadata-blocks">

      <!-- VOD -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.vod) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>VOD Metadata</div>
          </div>
          @for (metadata of recordMetadata.vod; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }
      <!-- MAX -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.max) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>MAX Metadata</div>
          </div>
          @for (metadata of recordMetadata.max; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }
      <!-- Linear -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.linear) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>Linear Metadata</div>
          </div>
          @for (metadata of recordMetadata.linear; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }
      <!-- Content Acquisition -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.contentAcquisition) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>Content Acquisition Metadata</div>
          </div>
          @for (metadata of recordMetadata.contentAcquisition; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }
      <!-- Archive -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.archive) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>Archive Metadata</div>
          </div>
          @for (metadata of recordMetadata.archive; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }
      <!-- C3 -->
      @if ((permissions | includesBy: 'record:update') && metadataTasks.c3) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>C3 Metadata</div>
          </div>
          @for (metadata of recordMetadata.c3; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }

      <!-- S3 Download -->
      @if (metadataTasks.s3Download) {
        <div class="row metadata-block" [class.disabled]="!(record.status === 'scheduled' || record.status === 'preparing' || record.status === 'inprogress')">
          <div class="title">
            <div>S3 Download Metadata</div>
          </div>
          @for (metadata of recordMetadata.s3Download; track metadata.key; let index = $index) {
            <div class="metadata">
              <input class="input static" [ngModel]="getDisplayKey(metadata.key)" (blur)="updateAdditionalMetadata()">
              <input class="input" [(ngModel)]="metadata.value" (blur)="updateAdditionalMetadata()">
            </div>
          }
        </div>
      }

    </div>

  </div>

  @if ((permissions | includesBy: 'record:update')) {
    <!-- Sticky action bar -->
    <div class="record-actions">
      <div class="button secondary" [class.disabled]="!editing" (click)="resetRecordChanges()">Reset</div>
      <div class="button" [class.disabled]="!editing" (click)="saveRecord()">Save</div>
    </div>
  }
}
